"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _formatNumber = _interopRequireDefault(require("format-number"));

var _checkTypes = _interopRequireDefault(require("check-types"));

var _busea = _interopRequireDefault(require("@seafront/busea.api"));

var _Constants = require("../00_environment/Constants");

var _ElementGroup = _interopRequireDefault(require("../01_atoms/ElementGroup"));

var _KeyValueElement = _interopRequireDefault(require("../01_atoms/KeyValueElement"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var formatPrice = function formatPrice(price) {
  return (0, _formatNumber["default"])({
    prefix: '$',
    round: 2,
    padRight: 2
  })(price);
};

var OrderPriceDetails = function OrderPriceDetails(_ref) {
  var title = _ref.title,
      outboundTrip = _ref.outboundTrip,
      returnTrip = _ref.returnTrip,
      nPassengers = _ref.nPassengers,
      translatorForNamespace = _ref.translatorForNamespace;
  var t = translatorForNamespace('OrderOrTripPriceDetails');

  var orderPricing = _busea["default"].getOrderPricing(outboundTrip, returnTrip, nPassengers);

  var outboundTripPricing = orderPricing.outboundTripPricing,
      returnTripPricing = orderPricing.returnTripPricing;
  return /*#__PURE__*/_react["default"].createElement(_ElementGroup["default"], {
    title: title || t('Price details')
  }, /*#__PURE__*/_react["default"].createElement(_KeyValueElement["default"], {
    slim: true,
    title: returnTrip ? t('Outbound ticket price') : t('Ticket price'),
    value: formatPrice(outboundTripPricing.grossPrice)
  }), returnTrip && /*#__PURE__*/_react["default"].createElement(_KeyValueElement["default"], {
    slim: true,
    title: t('Return ticket price'),
    value: formatPrice(returnTripPricing.grossPrice)
  }), _checkTypes["default"].positive(orderPricing.companyFee) && /*#__PURE__*/_react["default"].createElement(_KeyValueElement["default"], {
    slim: true,
    grayed: true,
    title: t('Company booking service'),
    value: formatPrice(orderPricing.companyFee)
  }), /*#__PURE__*/_react["default"].createElement(_KeyValueElement["default"], {
    slim: true,
    grayed: true,
    title: t(_Constants.serviceFeeName),
    value: formatPrice(orderPricing.buseaFee)
  }), /*#__PURE__*/_react["default"].createElement(_KeyValueElement["default"], {
    slim: true,
    grayed: true,
    title: t('Credit card payment fees'),
    value: formatPrice(orderPricing.paymentFee)
  }), /*#__PURE__*/_react["default"].createElement(_KeyValueElement["default"], {
    title: /*#__PURE__*/_react["default"].createElement("b", null, t('TOTAL')),
    value: /*#__PURE__*/_react["default"].createElement("b", null, formatPrice(orderPricing.total))
  }));
};

var _default = OrderPriceDetails;
exports["default"] = _default;